import { CourseBuilder } from '@modules/course/CourseBuilder/Blocks/types';

export function allBlockCategories(bottom = false) {
  if (bottom) {
    return [
      CourseBuilder.BlockCategory.text,
      CourseBuilder.BlockCategory.image,
      CourseBuilder.BlockCategory.multimedia,
      CourseBuilder.BlockCategory.list,
      CourseBuilder.BlockCategory.divider,
      // CourseBuilder.BlockCategory.todoList,
      // CourseBuilder.BlockCategory.drills,
      // CourseBuilder.BlockCategory.test,
    ];
  }
  return [
    CourseBuilder.BlockCategory.text,
    CourseBuilder.BlockCategory.image,
    CourseBuilder.BlockCategory.multimedia,
    CourseBuilder.BlockCategory.list,
    CourseBuilder.BlockCategory.divider,
    CourseBuilder.BlockCategory.statement,
    CourseBuilder.BlockCategory.quote,
    CourseBuilder.BlockCategory.gallery,
    CourseBuilder.BlockCategory.chart,
    CourseBuilder.BlockCategory.library,
    CourseBuilder.BlockCategory.todoList,
    CourseBuilder.BlockCategory.drills,
    CourseBuilder.BlockCategory.blockTemplate,
    // CourseBuilder.BlockCategory.special,
    // CourseBuilder.BlockCategory.test,
  ];
}
